import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import DashboardContainer from 'src/pages/dashboard';
import DistributeK1sContainer from 'src/pages/distribute-k1s';
import DocumentsContainer from 'src/pages/documents';
import SecuritySettingsContainer from 'src/pages/security-settings';
import TaxPaymentsContainer from 'src/pages/tax-payments';
import UserAccess from 'src/pages/user-access';
import ClientView from 'src/pages/client-view';
import MyDownloadsContainer from 'src/pages/my-downloads';
import { Toaster } from 'src/modules/notification/ute-notifier';
import LoggedInLayout from 'src/modules/layout/logged-in-layout';
import Logout from 'src/pages/logout';
import RestrictedSectionContainer from 'src/pages/section-access-denied';

const LoggedInUsers = () => {
	return (
<Router>
            <Routes>
                <Route
                    path='/access-denied'
                    element={<RestrictedSectionContainer />}
                />
                <Route
                    path='*'
                    element={
                        <LoggedInLayout>
                            <Routes>
                                <Route
                                    path='/'
                                    element={<DashboardContainer />}
                                />
                                <Route
                                    path='/documents'
                                    element={<DocumentsContainer />}
                                />
                                <Route
                                    path='/mydownloads'
                                    element={<MyDownloadsContainer />}
                                />
                                <Route
                                    path='/tax-payments'
                                    element={<TaxPaymentsContainer />}
                                />
                                <Route
                                    path='/distribute-k1s'
                                    element={<DistributeK1sContainer />}
                                />
                                <Route
                                    path='/security-settings'
                                    element={<SecuritySettingsContainer />}
                                />
                                <Route
                                    path='/access/:productType/:companyId'
                                    element={<UserAccess />}
                                />
                                <Route
                                    path='/clientview/:productType/:companyId/:cpaUserId'
                                    element={<ClientView />}
                                />
                                <Route
                                    path='/logout/:companyId/:auRegistrationId'
                                    element={<Logout />}
                                />
                                <Route
                                    path='*'
                                    element={
                                        <Navigate
                                            to='/'
                                            replace
                                        />
                                    }
                                />
                            </Routes>
                        </LoggedInLayout>
                    }
                />
            </Routes>
            <Toaster />
        </Router>
	);
};

export default LoggedInUsers;
